// extracted by mini-css-extract-plugin
export default {"logo":"components-Footer-themes-PP-logo__logo--Doq38","icon":"components-Footer-themes-PP-logo__icon--BjcHb","info":"components-Footer-themes-PP-logo__info--dV2_d"};